import { render, staticRenderFns } from "./sub_menu.vue?vue&type=template&id=0433c526&"
import script from "./sub_menu.vue?vue&type=script&lang=js&"
export * from "./sub_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports